import './style.scss'

const Notfound = () => {
  // const navigate = useNavigate()
  // useEffect(() => {
  //   setTimeout(() => {
  //     navigate(-1)
  //   }, 3000)
  // }, [])

  return (
    <div className='notfound_box'>
      <p>Lỗi không tìm thấy trang. Đường dẫn không đúng</p>
      <img src={process.env.PUBLIC_URL + '/images/404.jpg'} alt='Trang không tồn tại' />
    </div>
  )
}

export default Notfound
